import { createStyles } from 'antd-style'

export default createStyles(({ token }) => {
  return {
    name: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      gap: token.paddingXS,
    },
    inputValue: {
      flex: 1,
      '& > *': {
        width: '100%',
      },
    },
    remove: {
      width: 40,
      display: 'flex',
      justifyContent: 'center',

      button: {
        '&&': {
          padding: 0,
          width: 20,
          height: 20,
          color: token.gray700,
        },
      },
    },
  }
})
